"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const startCase_1 = __importDefault(require("lodash/startCase"));
const FormalReview_1 = require("utils/FormalReview");
const HelperUtils_1 = require("utils/HelperUtils");
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const UserContext_1 = require("src/context/UserContext");
const ProgressContentTable = ({ users, highCharts, onClickRow, currentPage, currentTab, sort, setSort, isLoading }) => {
    const { organization } = (0, UserContext_1.useUser)();
    const [customHeaders, setCustomHeaders] = (0, react_1.useState)([]);
    const [customColumns, setCustomColumns] = (0, react_1.useState)([]);
    const defaultHeaders = [
        { name: 'No', widthClass: 'w-[64px]' },
        {
            name: currentTab,
            widthClass: 'w-[240px]',
            grow: true,
            sort: {
                sortColumn: sort?.sortColumn,
                sortDirection: sort?.sortDirection,
                onSort: (direction) => setSort({ sortColumn: sort?.sortColumn, sortDirection: direction })
            }
        },
        { name: 'Manager', widthClass: 'w-[160px]', grow: true },
        { name: 'Review Deadline', widthClass: 'w-[160px]', grow: true, hide: true }
    ];
    const setCustomHeadersAndColumns = () => {
        const tempHeaders = [];
        const tempColumns = [];
        highCharts?.map((phase) => {
            const phaseType = (0, camelCase_1.default)(phase.type);
            tempHeaders.push({
                name: organization.identifier == 'bca'
                    ? (0, FormalReview_1.phaseShortName)(phase.type)
                    : (0, startCase_1.default)(phase.type),
                widthClass: 'w-[160px]',
                grow: true
            });
            tempColumns.push({
                header: organization.identifier == 'bca'
                    ? (0, FormalReview_1.phaseShortName)(phase.type)
                    : (0, startCase_1.default)(phase.type),
                phase: phaseType,
                type: currentTab === 'reviewer' ? 'submitted' : 'received'
            });
        });
        setCustomHeaders(tempHeaders);
        setCustomColumns(tempColumns);
    };
    (0, react_1.useEffect)(() => {
        if (highCharts?.length === 0 &&
            customHeaders?.length === 0 &&
            customColumns?.length === 0) {
            return;
        }
        setCustomHeadersAndColumns();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [highCharts]);
    return (react_1.default.createElement(Table_1.default, { headers: [...defaultHeaders, ...customHeaders], fixedLeftCount: 2, fixedLeftGrow: false, withHideColumn: true }, isLoading ? (react_1.default.createElement(LoadingComponent_1.default, null)) : (users?.map((user, index) => (react_1.default.createElement(Table_1.default.Row, { key: `table-row-${index}`, onClick: (e) => onClickRow(e, user), disabled: user?.userState === 'deleted', tooltip: {
            show: user?.userState === 'deleted',
            text: (0, HelperUtils_1.getObjectiveLocale)('This user has been deleted')
        }, dataCy: `table-row-${index}` },
        react_1.default.createElement(Table_1.default.Column, { key: "table-column-0", dataCy: "table-column-0" }, (currentPage - 1) * 10 + (index + 1)),
        react_1.default.createElement(Table_1.default.Column, { key: "table-column-1", dataCy: "table-column-1" },
            react_1.default.createElement(ProfileType_1.default, { user: user, title: user?.name, subtitle: (0, HelperUtils_1.getExtraInformation)(user?.title, user?.subtitle), size: 32, titleClassName: "typography-h400 text-n-800", subtitleClassName: "typography-h100 text-n-800" })),
        react_1.default.createElement(Table_1.default.Column, { key: "table-column-2", dataCy: "table-column-2" },
            react_1.default.createElement(TruncateParagraph_1.default, null, user?.manager?.name)),
        react_1.default.createElement(Table_1.default.Column, { key: "table-column-3", dataCy: "table-column-3" },
            react_1.default.createElement(TruncateParagraph_1.default, null, user?.assignmentProgresses?.latestAssignmentEndsAt
                ? (0, dayjs_1.default)(user?.assignmentProgresses?.latestAssignmentEndsAt).format('MMMM DD, YYYY')
                : '-')),
        customColumns?.map((column, columnIndex) => {
            const { state, done, total } = user.assignmentProgresses[column.phase] || {};
            return (react_1.default.createElement(Table_1.default.Column, { key: `table-column-${columnIndex + 4}`, dataCy: `table-column-${columnIndex + 4}` }, state?.length > 0 ? (react_1.default.createElement("div", { className: "flex flex-col justify-center" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-900" }, (0, startCase_1.default)(state === 'done' ? 'completed' : state)),
                react_1.default.createElement("p", { className: "typography-h100 text-n-800" }, `${done}/${total} ${column?.type}`))) : ('--')));
        })))))));
};
exports.default = ProgressContentTable;
